




































































import { Component } from 'vue-property-decorator';
import RouterAndStringMixin from "@/utils/CommonMixin";
import cr from "@/CompositionRoot";
import _ from "lodash";
import vuedraggable from 'vuedraggable'
import { Location, Locations } from "frontend-common";
import AddLocation from "@/components/dashboard/AddLocation.vue";

@Component({
    components: {
        AddLocation,
        draggable: vuedraggable
    }
}) export default class extends RouterAndStringMixin {

    private currentLocations: Locations = []
    private dragIndex = -1
    private progress = false

    created() {
        this.onReset()
    }

    mounted() {
        const route = this.$route
        const refs = this.$refs
        setTimeout(function () {
            if (!route.meta?.fromHistory) {
                (refs.add as HTMLElement).focus()
            }
        }, 100)

        this.bindShortcuts()
        this.addOnEscapeListener(() => this.$router.push(this.toEvent(this.uuid)))
        this.addOnSaveListener(() => this.onSubmit())
    }

    get uuid(): string {
        return this.$route.params.uuid
    }

    get locations(): Locations {
        return cr.myEventsModule.locationsByEvent(this.uuid)
    }

    startDrag(event: any) {
        this.dragIndex = event.oldIndex
    }

    endDrag() {
        this.dragIndex = -1
    }

    get hasChanges(): boolean {
        return !_.isEqual(this.currentLocations, _.clone(this.locations));
    }

    isEmpty(): boolean {
        return _.isEmpty(this.locations)
    }

    onLocationAdded(location: Location) {
        this.onReset()
        this.$bvModal.hide("add-location")
        this.$router.push(this.toLocation(location.id))
    }

    onLocationAddCancelled() {
        this.$bvModal.hide("add-location")
    }

    onReset() {
        this.currentLocations = _.clone(this.locations)
    }

    onSubmit(onSuccess: Function | null = null) {
        if (!this.hasChanges) {
            return
        }
        const locationIds = this.currentLocations.map(location => location.id)
        this.progress = true
        cr.myEventsService.updateLocationOrder(this.uuid, locationIds)
            .then(value => {
                this.onReset()
                if (onSuccess) {
                    onSuccess()
                }
            })
            .catch(reason => this.showError(reason))
            .finally(() => this.progress = false)
    }

    beforeRouteLeave(to: Location, from: Location, next: Function) {
        if (!this.hasChanges) {
            next()
            return
        }
        this.disableShortcuts()
        this.confirmSave().then(result => {
            this.enableShortcuts()
            if (result != null) {
                result ? this.onSubmit(next) : next()
            }
        })
    }
}
